import {
  Phone, Mail, MapPin, Clock, Facebook, Instagram, ExternalLink, Lock,
} from "lucide-react";

export default function Footer() {
  return (
    <footer
      className="py-12 section-surface border-t border-white/5"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          <div className="md:col-span-2">
            <span className="text-2xl font-black">
              Super<span className="text-[#00E5FF]">Majstri</span>
            </span>
            <p className="text-zinc-500 mt-4 text-sm leading-relaxed max-w-md">
              RESTOB s.r.o. - Profesionálna stavebná firma v Bratislave a okolí.
              Stavby na kľúč, holodomy, rekonštrukcie, zateplenia a ďalšie
              stavebné služby.
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a
                href="https://facebook.com/supermajstri.sk"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#00E5FF] hover:text-black transition-all"
              >
                <Facebook size={18} />
              </a>
              <a
                href="https://instagram.com/supermajstri"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#00E5FF] hover:text-black transition-all"
              >
                <Instagram size={18} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-bold mb-4 text-[#00E5FF]">Rýchle odkazy</h4>
            <ul className="space-y-2 text-sm text-zinc-400">
              <li>
                <a href="#sluzby" className="hover:text-white transition-colors">
                  Služby
                </a>
              </li>
              <li>
                <a href="#cennik" className="hover:text-white transition-colors">
                  Cenník
                </a>
              </li>
              <li>
                <a href="#portfolio" className="hover:text-white transition-colors">
                  Referencie
                </a>
              </li>
              <li>
                <a href="#kontakt" className="hover:text-white transition-colors">
                  Kontakt
                </a>
              </li>
              <li>
                <a href="/blog" className="hover:text-white transition-colors" data-testid="footer-blog-link">
                  Blog
                </a>
              </li>
              <li>
                <a href="/projekty" className="hover:text-white transition-colors" data-testid="footer-projekty-link">
                  Mapa projektov
                </a>
              </li>
              <li>
                <a
                  href="https://www.stavebne-dopyty.sk"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#00E5FF] transition-colors flex items-center gap-1"
                >
                  Stavebné dopyty
                  <ExternalLink size={12} />
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold mb-4 text-[#FF5E00]">Kontakt</h4>
            <ul className="space-y-2 text-sm text-zinc-400">
              <li className="flex items-center gap-2">
                <Phone size={14} className="text-[#00E5FF]" />
                <a href="tel:+421907649964" className="hover:text-white">
                  0907 64 99 64
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Mail size={14} className="text-[#00E5FF]" />
                <a
                  href="mailto:supermajstri.sk@gmail.com"
                  className="hover:text-white"
                >
                  supermajstri.sk@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-2">
                <MapPin size={14} className="text-[#00E5FF]" />
                <span>Kopčianska 10, Bratislava</span>
              </li>
              <li className="flex items-center gap-2">
                <Clock size={14} className="text-[#00E5FF]" />
                <span>Po-Pi: 7:00 - 19:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="text-center py-6 border-t border-b border-white/5 mb-8">
          <p className="text-zinc-500 text-sm mb-2">Člen siete</p>
          <a
            href="https://www.stavebne-dopyty.sk"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-[#00E5FF] hover:text-[#33EEFF] font-bold transition-colors"
          >
            www.stavebne-dopyty.sk
            <ExternalLink size={16} />
          </a>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-zinc-600 text-sm">
            © 2026 SuperMajstri - RESTOB s.r.o. Všetky práva vyhradené.
          </p>

          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-zinc-500">
            <a
              href="/ochrana-sukromia"
              className="hover:text-white transition-colors"
              data-testid="footer-privacy-link"
            >
              Ochrana súkromia
            </a>
            <a
              href="/cookies"
              className="hover:text-white transition-colors"
              data-testid="footer-cookies-link"
            >
              Cookies
            </a>
            <button
              onClick={() =>
                window.dispatchEvent(new Event("sm:reopen-cookies"))
              }
              className="hover:text-[#00E5FF] transition-colors"
              data-testid="footer-cookie-settings"
            >
              Nastavenia cookies
            </button>
            <a
              href="/login"
              className="inline-flex items-center gap-1.5 hover:text-[#00E5FF] transition-colors"
              data-testid="footer-admin-link"
            >
              <Lock size={12} />
              Admin
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
